import React from 'react';
import { getCaseStatusBadgeConfig } from '../../../lib/caseStatusUtils';

const StatusBadge = ({ status }) => {
  const config = getCaseStatusBadgeConfig(status);

  return (
    <span
      aria-label={config.ariaLabel}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;